export default {
	order: 15,
	description: "profile.visible.title",
	value_description: "profile.visible",
	type: "boolean",
	inputType: "switch",
	format: "switch",
};
